import { SCREENING_QUESTION } from '@/enum/screening-question-type.enum';

export const apiConst = {
  authLogin: 'auth/login',
  authLogout: 'auth/logout',
  authRefresh: 'auth/refresh',
  authSignUpOwner: 'auth/register-owner',
  authSignUp: 'auth/register-user',
  authTwoFactorSetup: 'auth/2fa/setup',
  authTwoFactorSetupVerify: 'auth/2fa/setup/verify',
  authTwoFactorLoginVerify: 'auth/2fa/login/verify',
  authForgotPassword: 'auth/forgot-password',
  authResetPassword: 'auth/reset-password',
  authPreviewClient: 'auth/preview/client',
  updateUser: '/auth',
  deleteUser: '/auth',
  getCompany: 'company',
  sentInvite: 'auth/sent-invite',
  acceptInvite: 'auth/accpet-invite',
  // getCompaniesByEmail: 'company/by-email',
  getCompaniesByToken: 'company/by-token',
  userDetails: 'user/detail',
  userProfilePhoto: 'user/detail/photo',
  userTwoFactorDisable: 'user/2fa/disable',
  setCompany: 'company/set-company',
  user: 'user',

  // project
  searchPeoples: 'searchPeoples',
  projects: 'projects',
  clientInfo: 'client-info',
  projectMembers: 'project-members',
  updateprojectMembersRole: 'project-members/role/',
  getAllProjects: 'projects',
  generateFilters: 'generatefilters',
  projectExpertDelete: 'expert/projectExpert',
  projectExpertBulkDelete: 'expert/projectExpert/bulk-delete',
  getProjectCreatePermissions: 'project-roles/all-permision-keys',
  getProjectRole: 'project-roles',
  createProjectRole: 'project-roles',
  updateProjectRole: 'project-roles',
  deleteProjectRole: 'project-roles',
  searchExperts: 'expert/search-experts',
  suggestedTenants: 'suggested-tenants',
  // meetings
  createSlots: 'meeting/createSlots',
  unscheduledMeetingList: 'meeting/unscheduled/',
  generateMeeting: 'meeting/book-slot/',
  //roles
  roles: 'roles',
  // allRoles: 'roles',
  getAllowedPermissions: 'roles/show-role-allowed',
  getAllPermissions: 'roles/getAllPermissions',
  expertupdateStatus: 'expert/update-status',
  createShareExpertLink: 'shared-links',
  getShareExpertLinkMeta: 'shared-links',
  getSharedProjectLink: 'projects',
  resolveProjectBySlug: 'projects/by-slug',
  assignExperts: 'expert/assign-experts',
  projectExpertAnswers: 'expert/project-expert',
  // projectExpertClientComment: 'expert/project-expert',
  publicProjectExpertClientComment: 'expert/public/project-expert',
  publicScreeningLink: 'expert/public/screening-link',
  publicScreeningQuestions: 'expert/public/screening',

  // expers
  experts: 'expert',
  getApprovedExperts: 'expert/approved?projectId=',
  getAllExperts: `expert`,
  getSubmittedExperts: `shared-links/`,
  publicApprovedStatus: `expert/public/update-approved-status`,
  clientApprovedStatus: `expert/client/update-approved-status`,

  expertStatusNotifications: '/expert/status-notifications',
  expertNotificationUnseenCount: '/expert/status-notifications/unseen-count',
  markExpertNotificationsSeen: '/expert/status-notifications/mark-seen',
  screeningNotifications: '/expert/screening-notifications',
  screeningNotificationUnseenCount: '/expert/screening-notifications/unseen-count',
  markScreeningNotificationsSeen: '/expert/screening-notifications/mark-seen',
  clientCommentNotifications: '/expert/client-comment-notifications',
  clientCommentNotificationUnseenCount: '/expert/client-comment-notifications/unseen-count',
  markClientCommentNotificationsSeen: '/expert/client-comment-notifications/mark-seen',
  commentConversation: '/expert/project-expert',
  commentConversationMessage: '/expert/comment-conversation',
  publicCommentConversation: '/expert/project-expert',
  publicCommentConversationMessage: '/expert/comment-conversation',
  publicExpertStatusNotifications: '/expert/public/status-notifications',
  markPublicExpertNotificationsSeen: '/expert/public/status-notifications/mark-seen',
  markClientSubmittedExpertNotificationsSeen: '/expert/client/status-notifications/mark-seen',
  clientProjectExpertClientComment: 'expert/client/project-expert',

  // overview
  getOverview: 'overview',
  getOverviewHistory: 'overview/history',
  // emails
  sendBulkMails: 'mail/send-bulk-emails',
  sendExpertMail: 'mail/send-expert-email',
  sendBulkExpertMail: 'mail/send-bulk-expert-email',
  sendCurrentProjectNdaMail: 'mail/send-current-project-nda',
  sendBulkCurrentProjectNdaMail: 'mail/send-bulk-current-project-nda',
  // expert email history & follow-up, NDA
  expertProjectEmail: 'expert/project-expert',
  // unlockedEmail
  unlockedEmail: 'unlockedEmail',

  // files
  uploadSingleFile: 'file/single',
  uploadMultipleFiles: 'file/multiple',
  projectAttachmentUrl: 'file/project-attachment',
  uploadSignedNda: 'file/upload-signed-nda',
  getSignedNdaUrl: 'file/nda-url',

  // chat
  sendMessage: 'sendMessage',
  clientsendMessage: 'clientsendMessage',
  chat: 'chat',
  clientChat: 'chat/clientChat',
  getMentionUsers: 'chat/getMention',
  preChat: 'pre-project-chat',
  preChatSendMessage: 'preChatSendMessage',
  unifiedChatProjectMessage: 'unified-chat-actions/project-message',
  unifiedChatClientProjectMessage: 'unified-chat-actions/client-project-message',
  unifiedChatProjectTyping: 'unified-chat-actions/project-typing',
  unifiedChatProjectStopTyping: 'unified-chat-actions/project-stop-typing',
  unifiedChatPreChatMessage: 'unified-chat-actions/pre-chat-message',
  unifiedChatPreChatTyping: 'unified-chat-actions/pre-chat-typing',
  unifiedChatPreChatStopTyping: 'unified-chat-actions/pre-chat-stop-typing',
  unifiedChatPreChatUnseenCount: 'unified-chat-actions/pre-chat-unseen-count',
  unifiedChatPreChatMarkSeen: 'unified-chat-actions/pre-chat-mark-seen',
  unifiedChatProjectUnseenCount: 'unified-chat-actions/project-unseen-count',
  unifiedChatProjectMarkSeen: 'unified-chat-actions/project-mark-seen',
};

export const keyConst = {
  userId: 'userId',
  companyId: 'companyId',
  userToken: 'userToken',
  rememberMe: 'rememberMe',
  appName: 'Alpha Insihts',
};

export const routeConst = {
  projectLink: '/project-link',
  projectDetail: '/project-detail',
  clientSignIn: '/auth/signin',
} as const;

export const twoFactorConst = {
  codeLength: 6,
  codePattern: /^\d{6}$/,
  setupPath: '/auth/two-factor-setup',
  verifyPath: '/auth/two-factor',
  requiresTwoFactor: 'requiresTwoFactor',
  requiresTwoFactorSetup: 'requiresTwoFactorSetup',
};

export const PROFILE_FIELD_CONST = {
  currentPassword: 'currentPassword',
} as const;

export const STATUS_FLOW = [
  'submitted',
  'delivered',
  'approved',
  'scheduled',
  'completed',
  'invoiced',
  'paid',
  'not relevant',
  'canceled',
];

export enum PROJECT_EXPERT_STATUS {
  SUBMITTED = 'submitted',
  DELIVERED = 'delivered',
  APPROVED = 'approved',
  SCHEDULED = 'scheduled',
  COMPLETED = 'completed',
  INVOICED = 'invoiced',
  PAID = 'paid',
  NOT_RELEVANT = 'not relevant',
  CANCELED = 'canceled',
}

export enum PROJECT_PERMISSION_KEY {
  VIEW_EXPERT_STATUS = 'view_expert_status',
  UPDATE_EXPERT_STATUS = 'update_expert_status',
  VIEW_CLIENT_INFO = 'view_client_info',
}

export enum COMPANY_PERMISSION_KEY {
  VIEW_CLIENT_DASHBOARD = 'view_client_dashboard',
  VIEW_USER = 'view_user',
  VIEW_ROLE = 'view_role',
}

export enum USER_ROLES_TAB {
  USERS = 'users',
  ROLES = 'roles',
}

export const USER_ROLES_TAB_LABEL = {
  USERS: 'Users',
  ROLES: 'Roles',
  MERGED: 'Users & Roles',
} as const;

export const USER_ROLES_QUERY_PARAM = {
  TAB: 'tab',
} as const;

export enum EXPERT_PAYMENT_MODE {
  WISE = 'WISE',
  BANK_TRANSFER = 'BANK_TRANSFER',
  PAYPAL = 'PAYPAL',
  GIFT_CARD = 'GIFT_CARD',
}

export enum CALL_DURATION_MINUTES {
  THIRTY = 30,
  FORTY_FIVE = 45,
  SIXTY = 60,
}

export const DEFAULT_COMPLETION_CURRENCY = 'USD';

export const EXPERT_PAYMENT_MODE_LABEL: Record<EXPERT_PAYMENT_MODE, string> = {
  [EXPERT_PAYMENT_MODE.WISE]: 'Wise',
  [EXPERT_PAYMENT_MODE.BANK_TRANSFER]: 'Bank Transfer',
  [EXPERT_PAYMENT_MODE.PAYPAL]: 'PayPal',
  [EXPERT_PAYMENT_MODE.GIFT_CARD]: 'Gift Card',
};

export const EXPERT_PAYMENT_MODE_SELECT_OPTIONS = Object.values(EXPERT_PAYMENT_MODE).map((value) => ({
  label: EXPERT_PAYMENT_MODE_LABEL[value],
  value,
}));

export const CALL_DURATION_SELECT_OPTIONS = Object.values(CALL_DURATION_MINUTES)
  .filter((value): value is CALL_DURATION_MINUTES => typeof value === 'number')
  .map((value) => ({
    label: `${value} mins`,
    value,
  }));

export const CLIENT_MEETING_SLOT_OPTIONS = [
  { label: 'Fixed', value: 'FIXED' },
  { label: '30 min', value: '30_MIN' },
  { label: '45 min', value: '45_MIN' },
  { label: '60 min', value: '60_MIN' },
  { label: '90 min', value: '90_MIN' },
];

export const UTC_TIMEZONE = 'Etc/UTC';
export const CLIENT_AVAILABILITY_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone || UTC_TIMEZONE;
export const PROJECT_LIST_DATE_LOCALE = 'en-US';
export const PROJECT_LIST_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
};

export const CLIENT_AVAILABILITY_DATE_FORMAT = 'YYYY-MM-DD';
export const CLIENT_AVAILABILITY_TIME_FORMAT = 'HH:mm';
export const CLIENT_AVAILABILITY_PARSE_FORMAT = `${CLIENT_AVAILABILITY_DATE_FORMAT} ${CLIENT_AVAILABILITY_TIME_FORMAT}`;
export const CLIENT_AVAILABILITY_DISPLAY_DATE_TIME_FORMAT = 'MMM D, YYYY, hh:mm A';
export const CLIENT_AVAILABILITY_DISPLAY_TIME_FORMAT = 'hh:mm A';
export const CLIENT_AVAILABILITY_PICKER_TIME_FORMAT = 'hh:mm A';
export const CLIENT_AVAILABILITY_SLOT_ID_PREFIX = 'availability';

export const CLIENT_AVAILABILITY_LABEL = {
  addSlot: 'Add Slot',
  availability: 'Availability',
  availabilitySlot: 'Availability Slot',
  date: 'Date',
  description: 'Add expert slots in their timezone. Clients will see the converted time automatically.',
  flexible: 'Flexible',
  notFlexible: 'Not flexible',
  endTime: 'End Time',
  startTime: 'Start Time',
  timeRange: 'Time Range',
  timezone: 'Timezone',
};

export const projectStatuses = [
  { label: 'Active', value: 'active' },
  // { label: 'On Review', value: 'on review' },
  { label: 'Closed', value: 'closed' },
  { label: 'Paused', value: 'paused' },
  { label: 'Completed', value: 'completed' },
];

export const OTHERS_OPTION = 'Others';

export const OTHERS_OPTION_PREFIX = 'Others::';

export const OTHERS_VALUE = (value: string): boolean => value === OTHERS_OPTION || value.startsWith(OTHERS_OPTION_PREFIX);

export const buildOthersValue = (customText: string): string =>
  customText.trim() ? `${OTHERS_OPTION_PREFIX}${customText}` : OTHERS_OPTION;

export const EXTRACT_OTHERS_TEXT = (value: string): string => {
  if (value.startsWith(OTHERS_OPTION_PREFIX)) return value.slice(OTHERS_OPTION_PREFIX.length);
  return '';
};

export const BULK_EMAIL_CONCURRENCY = 5;

export const SCREENING_QUESTION_TYPE_OPTIONS = [
  { label: 'Short answer', value: SCREENING_QUESTION.SHORT_TEXT },
  { label: 'Multiple choice', value: SCREENING_QUESTION.MULTI_CHOICE },
  { label: 'Likert scale', value: SCREENING_QUESTION.LIKERT_SCALE },
];
